<template>
<div class="swaychat-row">

  <iframe :src="src" style="display:none" ref="social"></iframe>

  <div class="swaychat-social-signin" v-if="!getMeta.source">
    <h5 class="swaychat-social-h5">{{ label }}</h5>
    <ul class="swaychat-social-icons">
      <li v-for="item in items" v-if="item && item.visible" @click="login(item.class)" :class="{
          'swaychat-signed-li-facebook': item.class == 'facebook',
          'swaychat-signed-li-google': item.class == 'google',
        }">
        <span>
          <i class="swaychat-icon" :class="{
            'swaychat-signin-facebook' : item.class == 'facebook',
            'swaychat-signin-google' : item.class == 'google',
          }">{{ item.name }}</i>
        </span>
      </li>
    </ul>
  </div>

  <div class="swaychat-row" v-for="item in items" v-if="item.class == getMeta.source">
  <div class="swaychat-social-signin">
    <h5 class="swaychat-social-h5">
      <a href="#" @click.prevent="logout(item.class)" :class="{
        'swaychat-signout-facebook' : item.class == 'facebook',
        'swaychat-signout-google' : item.class == 'google',
      }">{{ item.label }} {{ item.name }} (<span>Not you?</span>)</a>
    </h5>
    <ul class="swaychat-social-icons">
      <li @click.prevent="logout(item.class)" :class="{
          'swaychat-signed-li-facebook': item.class == 'facebook',
          'swaychat-signed-li-google': item.class == 'google',
        }">
        <span>
          <i class="swaychat-icon" :class="{
            'swaychat-signin-facebook' : item.class == 'facebook',
            'swaychat-signin-google' : item.class == 'google',
          }">{{ item.name }}</i>
        </span>
      </li>
    </ul>
  </div>
  </div>


</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  w
} from '../../utils/helpers'

export default {
  created() {
    window.addEventListener('message', this.listen)
  },
  data() {
    return {
      src: w.app('social'),
      ready: false
    }
  },
  props: [
    'label',
    'options'
  ],
  computed: {
    items() {
      let i = [].concat(this.options)
      return i.length ? i.splice(1,2) : []
    },
    lang() {
      return this.$store.getters.getLang
    },
    ...mapGetters([
      'getMeta',
    ])
  },
  methods: {
    send(type, data) {

      const payload = {
        swaychat_social: 'client',
        type,
        data
      }

      if (this.$refs.social && this.$refs.social.contentWindow)
        this.$refs.social.contentWindow.postMessage(JSON.stringify(payload), '*');

    },
    listen(e) {

      if (e &&
        e.data &&
        /swaychat_social/.test(e.data) &&
        e.origin.indexOf('@@CDN') > 0
      ) {

        const payload = JSON.parse(e.data)
        // console.log(payload)

        if (payload.type == 'connect') {
          this.ready = true
        }

        if (payload.type == 'loggedIn') {
          let user = payload.data
          this.$store.dispatch('saveMeta',{
            email: user.email || '',
            name: user.name || '',
            source: user.network,
            avatar: user.picture || user.thumbnail || ''
          })
        }

        if (payload.type == 'loggedOut') {
          this.$store.dispatch('saveMeta',{
            email: '',
            name: '',
            source: '',
            avatar: ''
          })
        }


      }
    },
    login(network) {

      this.send('login', {
        network
      })

    },
    logout(network) {

      this.send('logout', {
        network
      })

    }
  }
}
</script>
